import { call, put, takeLatest } from 'redux-saga/effects';
import { getInitSelectValues, getZipCodeAddress, saveEntry } from '../../../services/member/entry.service';
import {
  ACTION_TYPE,
  actCallApiInitSelectValuesSuccess,
  getZipCodeAddressSuccess,
  getZipCodeAddressUserSuccess,
  actSaveEntrySuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

function* callApiInitSelectValues() {
  try {
    const initSelectValues = yield call(getInitSelectValues);
    yield put(actCallApiInitSelectValuesSuccess(initSelectValues));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

function* callApiGetZipCodeAddress({ contidion }) {
  try {
    const zipCodeAddress = yield call(getZipCodeAddress, { zipCode: contidion.zipCode });
    if (contidion.pageFlg === 0) {
      yield put(getZipCodeAddressSuccess(zipCodeAddress));
    } else {
      yield put(getZipCodeAddressUserSuccess(zipCodeAddress));
    }
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

function* callApiSaveEntry({ param }) {
  try {
    const data = yield call(saveEntry, param);
    yield put(actSaveEntrySuccess(data));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallEntry() {
  yield takeLatest(ACTION_TYPE.CALL_API_INIT_SELECT_VALUES, callApiInitSelectValues);
  yield takeLatest(ACTION_TYPE.GET_ZIP_CODE_ADDRESS, callApiGetZipCodeAddress);
  yield takeLatest(ACTION_TYPE.CALL_API_SAVE_ENTRY, callApiSaveEntry);
}
